import React from 'react'
import { Pressable } from 'react-native'
import type { BottomTabBarButtonProps } from '@react-navigation/bottom-tabs'

// Styles
import { Colors } from 'APP/Themes'

const styles = {
  active: {
    borderTopColor: Colors.accent,
    backgroundColor: Colors.activeTabBackgroundColor,
  },
  inactive: {
    borderTopColor: Colors.elementsBg,
    backgroundColor: Colors.appBg,
  },
}

export const TabBarButton = (props: BottomTabBarButtonProps) => {
  const isSelected = props?.accessibilityState?.selected
  const style = isSelected ? styles.active : styles.inactive
  // isSelected is not a standard Pressable prop; cast to pass it through for tests
  const PressableAny = Pressable as React.ComponentType<
    React.ComponentProps<typeof Pressable> & { isSelected?: boolean }
  >
  return <PressableAny isSelected={isSelected} {...props} style={[style, props.style]} />
}
